import moment from "moment";

/**
 * Parse a DOB string from the API in either ISO ("YYYY-MM-DD") or legacy
 * DD-MM-YYYY format and return a moment instance. Accepts mixed legacy data
 * left over from the Spring Boot Lambda era.
 *
 * Returns an invalid moment if input is falsy or unparseable.
 */
export const parsePatientDob = (value) =>
  moment(value, ["YYYY-MM-DD", "DD-MM-YYYY"], true);

/**
 * Format a DOB value (ISO string, Date, or moment) for the API.
 * The api2_save_patient RPC expects ISO ("YYYY-MM-DD"). Returns null for
 * empty/unparseable input so the RPC's COALESCE preserves the existing value.
 */
export const formatPatientDobForApi = (value) => {
  if (!value) return null;
  const m = moment(value);
  return m.isValid() ? m.format("YYYY-MM-DD") : null;
};

/**
 * Format a DOB string for display. Preserves the prior DD-MM-YYYY UX while
 * accepting either input shape. Returns empty string if input is invalid.
 */
export const formatPatientDobForDisplay = (value) => {
  const m = parsePatientDob(value);
  return m.isValid() ? m.format("DD-MM-YYYY") : "";
};
